import { Link } from 'react-router-dom'
import { Button } from '@mui/material'

import Error from './Error'

import Binoculars from '../../../assets/animations/binoculars'
import useTranslations from '../../../i18n/useTranslations'
import * as routes from '../../../routes'

const Error404 = () => {
  const t = useTranslations()

  return (
    <Error title="error:404:title" text="error:404:text" image={<Binoculars />}>
      <Button component={Link} to={routes.HOME.linkTo()}>
        {t('action:back-to-home')}
      </Button>
    </Error>
  )
}

export default Error404
